import React from 'react'

const TempPlatform = () => {
  return <div>Platform</div>
}

export default TempPlatform
